<template>
  <HeadlineComponent>Bestätige deine Handynummer</HeadlineComponent>
  <form class="form-horizontal" @submit.prevent="confirm()">
    <p>Innerhalb der nächsten Minute solltest du eine SMS bekommen mit einem Bestätigungscode, gib diesen hier ein.</p>
    <div class="form-group">
      <label for="inputEmail">E-Mail Adresse</label>
      <input type="email" class="form-control" id="inputEmail" v-model="email" placeholder="E-Mail">
    </div>
    <div class="form-group">
      <label for="inputCode">Code</label>
      <input type="text" class="form-control" id="inputCode" v-model.number="code" placeholder="******">
    </div>
    <div class="form-group">
      <LoadingButton class="btn-primary" :loading="loading">Bestätigen</LoadingButton>
    </div>
    <p>
      <a href="#" @click.prevent="resendSms()" v-if="!smsLoading">Sollen wir die SMS nochmal versenden?</a>
      <span class="spinner-border spinner-border-sm" role="status" v-if="smsLoading">
        <span class="sr-only">Laden ...</span>
      </span>
    </p>
  </form>

</template>

<script>
import userService from "../services/user.service.js";
import {mapActions} from "pinia";
import {useAlertsStore} from "../stores/alerts.js";
import LoadingButton from "../components/LoadingButton.vue";
import HeadlineComponent from "../components/HeadlineComponent.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "ConfirmView",
  components: { LoadingButton, HeadlineComponent },
  data() {
    return {
      smsLoading: false,
      loading: false,
      email: '',
      code: ''
    }
  },
  mounted() {
    if(this.$route.query.email) {
      this.email = this.$route.query.email;
    }
  },
  methods: {
    ...mapActions(useAlertsStore, {addAlert: 'add'}),
    async resendSms() {
      this.smsLoading = true;
      if(!this.email) {
        this.addAlert('danger', 'Um die SMS neu zu senden, musst du die E-Mailadresse angeben, die du bei der Registrierung angegeben hast.');
        this.smsLoading = false;
        return;
      }
      try {
        let response = await userService.resendSms(this.email)
        if(response.data.success) {
          this.addAlert('success', response.data.message);
        } else {
          this.addAlert('danger', response.data.message);
        }
        this.smsLoading = false;
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
        this.smsLoading = false;
      }
    },
    async confirm() {
      this.loading = true;
      try {
        let response = await userService.confirm({
          email: this.email,
          code: this.code
        })
        if(response.data.success) {
          this.addAlert('success', response.data.message);
          this.$router.push('/login');
        } else {
          this.addAlert('danger', response.data.message);
        }
        this.loading = false;
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
form {
  width: 100%;
  max-width: 330px;
  margin: 0 auto;
  padding: 15px;
}
.form-group {
  text-align: center;
}

</style>